import activitiesService from '../../services/activitiesService'

class ActivitiesController {
  fetchActivities = activitiesService.fetchActivities
}

export default new ActivitiesController()
 


// WEBPACK FOOTER //
// ../src/controllers/activitiesController/activitiesController.js